import { Injectable } from '@angular/core';
import { ReportNameModalComponent } from '../../../shared/components/modals/report-name-modal.component';
import { Observable } from 'rxjs';
import { FeUtil } from '../../../hezky-routes';

@Injectable({
  providedIn: 'root'
})
export class UiService {
  constructor(public feUtil: FeUtil) { }

  saveReportModal(): Observable<any> {
    const modalRef = this.feUtil.modalSvc.create({
      nzTitle: 'Save Report',
      nzContent: ReportNameModalComponent,
      nzWidth: '400px',
      nzMaskClosable: false,
      nzClosable: true,
      nzCentered: true,
      nzOkText: 'Save',
      nzCancelText: 'Cancel',
      nzCloseOnNavigation: true
    });
    return modalRef.afterClose;
  }
}
